import { Box, InputAdornment, Stack, TextField, Tooltip } from "@mui/material";
import { Avatar } from "@src/appV2/lib/Avatar";
import { Button } from "@src/appV2/redesign/components/Button";
import { Dropdown } from "antd";

import { Icon } from "@src/appV2/redesign/components/Icon";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { Text } from "@src/appV2/redesign/components/Text";
import { AccountSwitcherMenuWorkplaceMobile } from "./AccountSwitcherDropdownWorkplace";
import { useAccountSwitcher } from "../../Shared/AccountSwitcher/useAccountSwitcher";
import { AccountSwitcherDropdownAdminMobile } from "./AccountSwitcherDropdownAdmin";

export function AccountSwitcherMobile() {
  const {
    switcherTitle,
    switcherSubtitle,
    displayAdminSwitcher,
    dropdownVisible,
    onAdminSearchBarEntered,
    onDropdownButtonClicked,
    onDropdownMouseLeave,
    workerDetails,
    workplaceDetails,
    onSearchChanged,
    onUserClicked,
    onAdminClicked,
  } = useAccountSwitcher();

  return (
    <Dropdown
      overlay={() => (
        <Box
          sx={(theme) => ({
            maxHeight: "60vh",
            overflowY: "auto",
            background: theme.palette.navbar?.gradient,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
            padding: 3,
          })}
          onMouseLeave={onDropdownMouseLeave}
        >
          {displayAdminSwitcher ? (
            <AccountSwitcherDropdownAdminMobile
              workerDetails={workerDetails}
              workplaceDetails={workplaceDetails}
              onUserClicked={onUserClicked}
            />
          ) : (
            <AccountSwitcherMenuWorkplaceMobile
              workplaceDetails={workplaceDetails}
              onUserClicked={onUserClicked}
            />
          )}
        </Box>
      )}
      visible={dropdownVisible}
      placement="bottomRight"
      overlayStyle={{ zIndex: 1300 }}
      getPopupContainer={(trigger) => trigger.parentElement || document.body}
    >
      {displayAdminSwitcher ? (
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search agents or workplaces..."
          autoComplete="off"
          sx={(theme) => ({
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background?.inverted?.muted,
              color: theme.palette.navbar?.itemContentSelected,
              paddingRight: 0,
              "& fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.normal?.borderColor,
              },
              "&:hover fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
              "&.Mui-focused fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
            },
            "& .MuiOutlinedInput-input": {
              color: theme.palette.navbar?.itemContentSelected,
              "&::placeholder": {
                color: theme.palette.navbar?.itemContent,
                opacity: 1,
              },
            },
          })}
          onClick={onAdminSearchBarEntered}
          onChange={(event) => {
            onSearchChanged(event.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ marginLeft: 0, paddingLeft: 0 }}>
                <Tooltip title="Switch To Admin">
                  <span>
                    <IconButton
                      variant="linkInverted"
                      iconType="person-male-formal"
                      sx={(theme) => ({
                        borderRadius: 0,
                        borderLeft: `1px solid ${theme.palette.button?.outline?.inverted?.normal?.borderColor}`,
                        paddingX: 3,
                        height: "100%",
                        "&:hover": {
                          backgroundColor: theme.palette.background?.inverted?.muted,
                        },
                      })}
                      onClick={(e) => {
                        e.stopPropagation();
                        onAdminClicked();
                      }}
                    />
                  </span>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      ) : (
        <Button
          variant="outlineInverted"
          sx={{
            height: "100%",
            flexGrow: 1,
            flexShrink: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "none",
          }}
          onClick={onDropdownButtonClicked}
        >
          <Avatar
            name={switcherTitle}
            size="small"
            sx={(theme) => ({
              bgcolor: theme.palette.navbar?.avatarBackground,
              color: theme.palette.navbar?.avatarText,
              flexShrink: 0,
            })}
          />
          <Stack direction="column" flex={1} minWidth={0}>
            <Text
              variant="body1"
              textAlign="left"
              color={(theme) => theme.palette.navbar?.userName}
              noWrap
            >
              {switcherTitle}
            </Text>
            {switcherSubtitle && (
              <Text variant="caption" textAlign="left" noWrap>
                {switcherSubtitle}
              </Text>
            )}
          </Stack>
          <Icon
            type="caret-bottom"
            sx={(theme) => ({
              color: theme.palette.button?.outline.inverted.hover.color,
              flexShrink: 0,
            })}
          />
        </Button>
      )}
    </Dropdown>
  );
}

/*        */
